module.exports = __webpack_public_path__ + "static/media/imgBgEtiqa.09566b42.jpg";